import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_BOOSTER } from '@/modules/booster/router';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { computed, ref } from 'vue';
import { RouteLocationRaw } from 'vue-router';

export enum PromotionBoosterLinkableType {
    PromotionItem = 1,
    BoosterItem = 2
}

export function useMixins() {
    const linkableItems = ref([]);
    const fetchLinkableItems = useCrudActions().executeAction({
        request: promotionService.booster.getLinkableItems,
        onSuccess: ({ data }) => {
            linkableItems.value = data.map((item: any) => ({
                id: item.itemId,
                name: item.itemName,
                type: item.type
            }));
        },
        onError: () => void (linkableItems.value = [])
    });

    const promotionOption = computed(() =>
        linkableItems.value
            .filter(item => item.type === PromotionBoosterLinkableType.PromotionItem)
            .map(item => ({ label: item.name, value: item.id }))
    );

    const boosterOption = computed(() =>
        linkableItems.value
            .filter(item => item.type === PromotionBoosterLinkableType.BoosterItem)
            .map(item => ({ label: item.name, value: item.id }))
    );

    const getItemName = (type: number, id: number) => {
        return linkableItems.value.find(item => item.id === id && item.type === type)?.name ?? '';
    };

    const getItemLink = (type: number, data: number): RouteLocationRaw => {
        if (!type || !data) return {};

        switch (type) {
            case PromotionBoosterLinkableType.PromotionItem:
                return { name: ROUTE_NAME_PROMOTION.ITEM.DETAIL, params: { id: data } };
            case PromotionBoosterLinkableType.BoosterItem:
                return { name: ROUTE_NAME_BOOSTER.EDIT, params: { type: data } };
            default:
                return {};
        }
    };

    return { fetchLinkableItems, promotionOption, boosterOption, getItemLink, getItemName };
}
